import api from '@/libs/api'
import store from '@/store'

const organizationId = () => store.state.app.organizationId

export default {
  namespaced: true,
  state: {
    paymentMethods: [],
    paymentMethodsResultInfo: {},
    fetchingPaymentMethods: false,
    addingPaymentMethod: false,
    removingPaymentMethod: false,
    updatingPaymentMethod: false,
    gettingPaymentMethod: false,
    paymentMethod: {},
    payments: [],
    paymentsResultInfo: {},
    clientSecret: '',
    fetchingPayments: false,
    payment: {},
    gettingPayment: false,
    invoices: [],
    invoicesResultInfo: {},
    fetchingInvoices: false,
    invoice: {},
    gettingInvoice: false,
    gettingUpcomingInvoice: false,
    upcomingInvoice: {},
  },
  mutations: {
    SET_PAYMENT_METHODS(state, data) {
      state.paymentMethods = data.result
      state.paymentMethodsResultInfo = data.resultInfo
    },
    SET_MORE_PAYMENT_METHODS(state, data) {
      state.paymentMethods = [...state.paymentMethods, ...data.result]
      state.paymentMethodsResultInfo = data.resultInfo
    },
    RESET_PAYMENT_METHODS(state, limit) {
      state.paymentMethods.splice(limit)
      state.paymentMethodsResultInfo.hasMore = true
    },
    SET_FETCHING_PAYMENT_METHODS(state, value) {
      state.fetchingPaymentMethods = value
    },
    SET_ADDING_PAYMENT_METHOD(state, value) {
      state.addingPaymentMethod = value
    },
    SET_UPDATING_PAYMENT_METHOD(state, value) {
      state.updatingPaymentMethod = value
    },
    SET_REMOVING_PAYMENT_METHOD(state, value) {
      state.removingPaymentMethod = value
    },
    REMOVE_PAYMENT_METHOD(state, id) {
      state.paymentMethods = state.paymentMethods.filter(p => p.id !== id)
    },
    SET_GETTING_PAYMENT_METHOD(state, value) {
      state.gettingPaymentMethod = value
    },
    SET_PAYMENT_METHOD(state, data) {
      state.paymentMethod = data
    },
    SET_PAYMENTS(state, data) {
      state.payments = data.result
      state.paymentsResultInfo = data.resultInfo
    },
    SET_MORE_PAYMENTS(state, data) {
      state.payments = [...state.payments, ...data.result]
      state.paymentsResultInfo = data.resultInfo
    },
    RESET_PAYMENTS(state, limit) {
      state.payments.splice(limit)
      state.paymentsResultInfo.hasMore = true
    },
    SET_PAYMENT(state, data) {
      state.payment = data
    },
    SET_GETTING_PAYMENT(state, value) {
      state.gettingPayment = value
    },
    SET_FETCHING_PAYMENTS(state, value) {
      state.fetchingPayments = value
    },
    SET_SECRET(state, res) {
      state.clientSecret = res.clientSecret
    },
    SET_INVOICES(state, data) {
      state.invoices = data.result
      state.invoicesResultInfo = data.resultInfo
    },
    SET_MORE_INVOICES(state, data) {
      state.invoices = [...state.invoices, ...data.result]
      state.invoicesResultInfo = data.resultInfo
    },
    RESET_INVOICES(state, limit) {
      state.invoices.splice(limit)
      state.invoicesResultInfo.hasMore = true
    },
    SET_FETCHING_INVOICES(state, value) {
      state.fetchingInvoices = value
    },
    SET_INVOICE(state, data) {
      state.invoice = data
    },
    SET_GETTING_INVOICE(state, value) {
      state.gettingInvoice = value
    },
    SET_UPCOMING_INVOICE(state, data) {
      state.upcomingInvoice = data
    },
    SET_GETTING_UPCOMING_INVOICE(state, value) {
      state.gettingUpcomingInvoice = value
    },
  },
  actions: {
    fetchPaymentMethods({ commit }, query) {
      commit('SET_FETCHING_PAYMENT_METHODS', true)
      let url = `/organizations/${organizationId()}/payment-methods`
      if (query && query.limit) {
        url += `?limit=${query.limit}`
      }
      if (query && query.startingAfter) {
        url += `&StartingAfter=${query.startingAfter}`
      }
      return new Promise((resolve, reject) => {
        api('captain').get(url)
          .then(response => {
            if (query.startingAfter) {
              commit('SET_MORE_PAYMENT_METHODS', response.data)
            } else {
              commit('SET_PAYMENT_METHODS', response.data)
            }
            resolve(response)
          })
          .catch(error => {
            reject(error)
            commit('SET_PAYMENT_METHODS', { result: [] })
          })
          .finally(() => { commit('SET_FETCHING_PAYMENT_METHODS', false) })
      })
    },

    addPaymentMethod({ commit }, id) {
      const orgId = id || organizationId()
      commit('SET_ADDING_PAYMENT_METHOD', true)
      return new Promise((resolve, reject) => {
        api('captain').post(`/organizations/${orgId}/payment-methods`)
          .then(response => {
            commit('SET_SECRET', response.data.result)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_ADDING_PAYMENT_METHOD', false) })
      })
    },

    updatePaymentMethod({ commit }, paymentMethod) {
      commit('SET_UPDATING_PAYMENT_METHOD', true)
      return new Promise((resolve, reject) => {
        api('captain').put(`/organizations/${organizationId()}/payment-methods/${paymentMethod.id}`, paymentMethod)
          .then(response => { resolve(response) })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_UPDATING_PAYMENT_METHOD', false) })
      })
    },

    getPaymentMethod({ commit }, id) {
      commit('SET_GETTING_PAYMENT_METHOD', true)
      return new Promise((resolve, reject) => {
        api('captain').get(`/organizations/${organizationId()}/payment-methods/${id}`)
          .then(response => {
            commit('SET_PAYMENT_METHOD', response.data.result)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_GETTING_PAYMENT_METHOD', false) })
      })
    },

    removePaymentMethod({ commit }, id) {
      commit('SET_REMOVING_PAYMENT_METHOD', true)
      return new Promise((resolve, reject) => {
        api('captain').delete(`/organizations/${organizationId()}/payment-methods/${id}`)
          .then(response => {
            commit('REMOVE_PAYMENT_METHOD', id)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_REMOVING_PAYMENT_METHOD', false) })
      })
    },

    fetchPayments({ commit }, query) {
      commit('SET_FETCHING_PAYMENTS', true)
      let url = `/organizations/${organizationId()}/payments`
      if (query && query.limit) {
        url += `?limit=${query.limit}`
      }
      if (query && query.startingAfter) {
        url += `&StartingAfter=${query.startingAfter}`
      }
      return new Promise((resolve, reject) => {
        api('captain').get(url)
          .then(response => {
            if (query.startingAfter) {
              commit('SET_MORE_PAYMENTS', response.data)
            } else {
              commit('SET_PAYMENTS', response.data)
            }
            resolve(response)
          })
          .catch(error => {
            reject(error)
            commit('SET_PAYMENTS', { result: [] })
          })
          .finally(() => { commit('SET_FETCHING_PAYMENTS', false) })
      })
    },

    getPayment({ commit }, id) {
      commit('SET_GETTING_PAYMENT', true)
      return new Promise((resolve, reject) => {
        api('captain').get(`/organizations/${organizationId()}/payments/${id}`)
          .then(response => {
            commit('SET_PAYMENT', response.data.result)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_GETTING_PAYMENT', false) })
      })
    },

    fetchInvoices({ commit }, query) {
      commit('SET_FETCHING_INVOICES', true)
      let url = `/organizations/${organizationId()}/invoices`
      if (query && query.limit) {
        url += `?limit=${query.limit}`
      }
      if (query && query.startingAfter) {
        url += `&StartingAfter=${query.startingAfter}`
      }
      return new Promise((resolve, reject) => {
        api('captain').get(url)
          .then(response => {
            if (query.startingAfter) {
              commit('SET_MORE_INVOICES', response.data)
            } else {
              commit('SET_INVOICES', response.data)
            }
            resolve(response)
          })
          .catch(error => {
            reject(error)
            commit('SET_INVOICES', { result: [] })
          })
          .finally(() => { commit('SET_FETCHING_INVOICES', false) })
      })
    },

    getInvoice({ commit }, id) {
      commit('SET_GETTING_INVOICE', true)
      return new Promise((resolve, reject) => {
        api('captain').get(`/organizations/${organizationId()}/invoices/${id}`)
          .then(response => {
            commit('SET_INVOICE', response.data.result)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_GETTING_INVOICE', false) })
      })
    },

    getUpcomingInvoice({ commit }) {
      commit('SET_GETTING_UPCOMING_INVOICE', true)
      return new Promise((resolve, reject) => {
        api('captain').get(`/organizations/${organizationId()}/invoices/upcoming`)
          .then(response => {
            commit('SET_UPCOMING_INVOICE', response.data.result)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_GETTING_UPCOMING_INVOICE', false) })
      })
    },
  },
}
